export default{
    operadores:[],
    reporte:[],
    act:null,
    fields:'',
    error:null,
    errorMessage:'',
    totalRow:null,
    
    
}